import React from 'react'
import {connect} from "react-redux"
//import {withRouter} from 'react-router'

//import {adminFetchUsers, adminSetUserAdmin, adminSetUserConfirmed} from "../../actions/admin"
import {setTitle, fetchUser} from "../../actions/index"

import UserProfileHeader from './UserProfileHeader'
import {withRouter} from 'react-router'

//import styles
//import './styles/UserProfile.scss';


@connect((store) => {
	return {
    users: store.users,
	  User: store.User.User,
    app: store.app
   }
})
class UserProfile extends React.Component {
	constructor(props) {
		super(props);
    this.getUser = this.getUser.bind(this);
		this.editButton = this.editButton.bind(this)
		this.goToEditUser = this.goToEditUser.bind(this)
    this.state = {
      user: {name:''}
    }
	}

	goToEditUser(){
		this.props.router.push('/admin/user/'+this.state.user.uid)
	}

	editButton(){

		if(this.props.User.admin){
			return <a onClick={this.goToEditUser} className=" link">Edit</a>
		}else {
			return null
		}
	}

  getUser(){
    let user = this.props.users.find(user => {
      return user.uid === this.props.params.id
    })

		if(!user){
			this.props.dispatch(fetchUser(this.props.params.id))
			.then((user)=>{
				this.setState({
		      user: user || {name:'User not found'}
		    });
			})
		}else{
	    this.setState({
	      user: user || {name:'User not found'}
	    });
		}

    this.props.dispatch(setTitle('User Profile'));
	}
	
  componentDidMount(){
    this.getUser();
  }

	render() {
		const { user } = this.state;
			return <main className="main user-profile-page">
        <UserProfileHeader user={user}>

        </UserProfileHeader>
        <div className="page">
					{this.editButton()}
          <br />{this.props.children}<br /><br />
					
        </div>

			</main>
	}
}

export default withRouter(UserProfile);



// WEBPACK FOOTER //
// ./src/components/user/UserProfile.jsx